import React from 'react';
import PropTypes from 'prop-types';

import {
  Avatar,
  Box,
  Button,
  Typography
} from '@mui/material';

import {
  BadgeOutlined,
  CheckCircleOutlined,
  EditOutlined,
  EmailOutlined,
  LocalPhoneOutlined,
  MedicalServicesOutlined,
  MedicalInformationOutlined,
  
} from '@mui/icons-material';

import {
  cardHeaderSx,
  cardSx,
  cardTitleSx,
  editButtonSx,
  providerAvatarSx,
  providerContentSx,
  providerFieldSx,
  providerFieldsSx,
  providerIconSx,
  providerLabelSx,
  providerValueSx,
  providerWideFieldSx
} from './styles';

import {DoctorOutlined} from '../../../Common/components/Icons/icons';

const ProfileField = ({
  icon,
  label,
  sx,
  value
}) => (
  <Box sx={sx}>
    {React.cloneElement(icon, {
      sx: providerIconSx
    })}

    <Box sx={{ minWidth: 0 }}>
      <Typography sx={providerLabelSx}>
        {label}
      </Typography>

      <Typography
        title={value}
        sx={providerValueSx}
      >
        {value}
      </Typography>
    </Box>
  </Box>
);

ProfileField.propTypes = {
  icon: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  sx: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.func,
    PropTypes.object
  ]).isRequired,
  value: PropTypes.string.isRequired
};

const ProviderProfileCard = ({
  data,
  onEdit
}) => {
  const initials = `${data.firstName?.[0] || ''}${data.lastName?.[0] || ''}`;

  return (
    <Box sx={cardSx}>
      <Box sx={cardHeaderSx}>
        <Typography sx={cardTitleSx}>
          Provider Profile
        </Typography>

        <Button
          onClick={onEdit}
          startIcon={<EditOutlined sx={{fontSize:18}}/>}
          sx={editButtonSx}
          variant="outlined"
          size='small'
        >
          Edit
        </Button>
      </Box>

      <Box sx={providerContentSx}>
        <Avatar sx={providerAvatarSx}>
          {initials}
        </Avatar>

        <Box sx={providerFieldsSx}>
          <Box sx={providerFieldSx}>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={providerLabelSx}>
                First Name
              </Typography>

              <Typography sx={providerValueSx}>
                {data.firstName}
              </Typography>
            </Box>
          </Box>

          <Box sx={providerFieldSx}>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={providerLabelSx}>
                Last Name
              </Typography>

              <Typography sx={providerValueSx}>
                {data.lastName}
              </Typography>
            </Box>
          </Box>

          <ProfileField
            icon={<EmailOutlined />}
            label="Email"
            sx={providerFieldSx}
            value={data.email}
          />

          <ProfileField
            icon={<LocalPhoneOutlined />}
            label="Phone Number"
            sx={providerFieldSx}
            value={data.phoneNumber}
          />

          <ProfileField
            icon={<MedicalInformationOutlined />}
            label="License Number"
            sx={providerFieldSx}
            value={data.licenseNumber}
          />

          <ProfileField
            icon={<CheckCircleOutlined />}
            label="Individual NPI"
            sx={providerFieldSx}
            value={data.individualNpi}
          />

          <ProfileField
            icon={<MedicalInformationOutlined />}
            label="DEA Number"
            sx={providerFieldSx}
            value={data.deaNumber}
          />

          <ProfileField
            icon={<DoctorOutlined sx={{fontSize:'22!important'}}/>}
            label="Specialization"
            sx={providerFieldSx}
            value={data.specialization}
          />
        </Box>
      </Box>
    </Box>
  );
};

ProviderProfileCard.propTypes = {
  data: PropTypes.shape({
    deaNumber: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    individualNpi: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    licenseNumber: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    specialization: PropTypes.string.isRequired
  }).isRequired,
  onEdit: PropTypes.func.isRequired
};

export default ProviderProfileCard;